import { render, staticRenderFns } from "./UserMediaNav.vue?vue&type=template&id=7ddf95b1&scoped=true"
import script from "./UserMediaNav.vue?vue&type=script&lang=js"
export * from "./UserMediaNav.vue?vue&type=script&lang=js"
import style0 from "./UserMediaNav.vue?vue&type=style&index=0&id=7ddf95b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf95b1",
  null
  
)

export default component.exports